import React from 'react';
import { IconProps } from '../IconProps';
const SvgSolidLock = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M11.131 8a.723.723 0 01-.722-.723V4.146A2.412 2.412 0 008 1.737a2.412 2.412 0 00-2.409 2.409v3.131a.723.723 0 01-1.445 0V4.146A3.858 3.858 0 018 .292a3.858 3.858 0 013.854 3.854v3.131a.723.723 0 01-.723.723z"
      fill={primaryColor}
    />
    <path
      d="M11.613 6.555H4.387a2.652 2.652 0 00-2.65 2.65v3.853a2.652 2.652 0 002.65 2.65h7.226a2.652 2.652 0 002.65-2.65V9.204a2.652 2.652 0 00-2.65-2.65zm-2.89 5.058a.723.723 0 01-1.446 0v-.963a.723.723 0 011.446 0v.963z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgSolidLock;
